import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase";

const setAsAdmin = httpsCallable<{ uid: string }, any>(functions, "setAsAdmin");
const setAsUser = httpsCallable<{ uid: string }, any>(functions, "setAsUser");
const deleteUserByUid = httpsCallable<{ uid?: string; id?: string }, any>(functions, "deleteUserByUid");
const associateUserWithOperator = httpsCallable<{ uid: string; fleetOperatorId: string }, any>(functions, "associateUserWithOperator");

export const upgradeToAdmin = async (uid: string): Promise<any> => {
  return setAsAdmin({ uid });
};

export const downgradeToUser = async (uid: string): Promise<any> => {
  return setAsUser({ uid });
};

export const deleteUser = async (target?: string | { uid?: string; id?: string }): Promise<any> => {
  if (typeof target === "string") {
    return deleteUserByUid({ uid: target });
  }
  return deleteUserByUid(target || {});
};

export const associateUserWithFleetOperator = async (uid: string, fleetOperatorId: string): Promise<any> => {
  return associateUserWithOperator({ uid, fleetOperatorId });
};